import type { StyleRenderer, RenderParams, RendererContext } from '../../types';
import { registerRenderer } from './base';
import { drawUchiwaBackground, drawUchiwaBorder, cornerRadiusPx } from '../uchiwa-shape';
import { layoutText, drawChars } from '../text';
import { UCHIWA_SIZES } from '../../types';

const simpleRenderer: StyleRenderer = {
  name: 'simple',
  label: 'シンプル',
  description: 'Clean flat text style',

  render(ctx: CanvasRenderingContext2D, params: RenderParams, _rc: RendererContext): void {
    const { text, textColor, backgroundColor, canvasWidth, canvasHeight, textOrientation } = params;

    const cr = cornerRadiusPx(
      UCHIWA_SIZES.jumbo.cornerRadius,
      UCHIWA_SIZES.jumbo.printableArea.width,
      canvasWidth,
    );

    drawUchiwaBackground(ctx, { canvasWidth, canvasHeight, cornerRadius: cr, backgroundColor });

    // Usable area (inset from edges)
    const pad = canvasWidth * 0.08;
    const areaW = canvasWidth - pad * 2;
    const areaH = canvasHeight - pad * 2;
    const cx = canvasWidth / 2;
    const cy = canvasHeight / 2;

    const positions = layoutText(ctx, {
      text,
      orientation: textOrientation,
      fontFamily: 'Noto Sans JP',
      fontWeight: 'bold',
      areaWidth: areaW,
      areaHeight: areaH,
      centerX: cx,
      centerY: cy,
    });

    drawChars(ctx, positions, 'Noto Sans JP', 'bold', textColor);

    drawUchiwaBorder(ctx, { canvasWidth, canvasHeight, cornerRadius: cr, backgroundColor });
  },

  renderThumbnail(ctx: CanvasRenderingContext2D, size: number): void {
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, size, size);
    ctx.fillStyle = '#FF6B9D';
    ctx.font = `bold ${size * 0.4}px sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('A', size / 2, size / 2);
  },
};

registerRenderer(simpleRenderer);
export default simpleRenderer;
